export default store => (store ? store.state.auth.user : null);



// WEBPACK FOOTER //
// ./src/kindergarten/child.js